
export default function GalleryHero() {
  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1480219221d41f1d5ee8d12ba91b76b3.jpg"
          alt="Gallery Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <p className="text-amber-400 text-sm font-medium tracking-wider uppercase mb-4">Our Portfolio</p>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
          Our Project Gallery
        </h1>
        <p className="text-xl md:text-2xl text-white/95 font-light leading-relaxed">
          Explore our finest painting and decorating projects. Each project showcases our commitment to quality, attention to detail, and exceptional craftsmanship.
        </p>
      </div>
    </section>
  );
}
